module.exports = __webpack_public_path__ + "img/youtube.0315b5ad.svg";